import React, { Component } from 'react';
import { Container, Header, Icon, Image, Button } from 'semantic-ui-react';
import './home.css';

class MessageOfTheDayCard extends Component {
  genHeader() {
    if (this.props.mobile != true) {
      return (
        <Header as="h3">
          <Icon color="grey" name="comment outline" />
          Message of The Day
        </Header>
      );
    }
  }
  genmotd() {
    if (this.props.motd) {
      return (
        <Container>
          <h4>{this.props.motd.title}</h4>
          <Image src={this.props.motd.src} id='motdimg'/>
          <p>{this.props.motd.message}</p>
          <Button
            basic
            compact
            attached="bottom"
            onClick={() => this.props.handlemodal()}
          >
            <Icon name="pencil" />Edit/Create MOtD
          </Button>
          <Button basic compact attached="bottom">
            <Icon name="disk outline" />MoTD Archive
          </Button>
        </Container>
      );
    }
  }
  render() {
    return (
      <div>
        <Header as="h3">
          <Icon color="grey" name="comment outline" />
          Message of The Day
        </Header>
        {this.genmotd()}
      </div>
    );
  }
}
export default MessageOfTheDayCard;



// WEBPACK FOOTER //
// ./src/components/home-components/messageoftheday.js